<template>
    <div class="payCert">
        <div class="title">购买证书</div>
        <div class="pay">
            <div class="mkll">
                名称：<span>{{orderList.shopName}}</span>
            </div>
            <div class="mkll">
                有效期：
                <span v-if="orderList.type == 0">{{orderList.norms}}次</span>
                <span v-else>{{orderList.norms}}天</span>
            </div>

            <div class="mkll">
                金额（元）：
                <div class="money"><span>￥</span>{{orderList.price}}</div>
            </div>
            <div class="mkll">
                实付款（元）：
                <div class="money"><span>￥</span>{{orderList.price}}</div>
            </div>

            <div class="line"></div>

            <div class="title">
                付款方式
            </div>
            <div class="select">
                <div class="moneyPay">
                    <el-checkbox v-model="payZFBChecked" @change="payZFB"></el-checkbox>
                    <img src="../../../../static/img/zhifubao.png"/>
                    企业支付宝
                </div>
                <div class="moneyPay">
                    <el-checkbox v-model="payWXChecked" @change="payWX"></el-checkbox>
                    <img src="../../../../static/img/wx.png"/>
                    微信
                </div>
            </div>
            <div class="line"></div>
            <div class="pay_btn">
                <div class="btn" @click="handlCheckSubmit">提交</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                payZFBChecked: true,
                payWXChecked: false,
                orderList: '',
                signatureId: ''
            }
        },
        mounted() {
            //印章id，添加订单必传
            this.signatureId = this.$route.query.signatureId;
            if (!this.$route.query.orderList) {
                this.$router.push('buyCert');
            } else {
                this.orderList = JSON.parse(this.$route.query.orderList)
            }
        },
        methods: {
            handlCheckSubmit() {
                let _this = this;
                _this.$confirm('是否下单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: ''
                }).then(() => {
                    let param = new FormData();
                    param.append('type',  1);
                    param.append('token', _this.$global.token);
                    param.append('certId', _this.orderList.id);
                    if (_this.payZFBChecked) {
                        param.append('orderChannel', 0);
                    } else if (_this.payWXChecked) {
                        param.append('orderChannel', 1);
                    }
                    param.append('signatureId', this.signatureId);
                    _this.api.addOrderInfo(param).then(res => {
                        console.log(res);
                        _this.$message.success('下单成功');
                        _this.$router.push('myOrder');
                    })
                }).catch(() => {
                })
            },
            payZFB() {
                this.payWXChecked = !this.payWXChecked
            },
            payWX() {
                this.payZFBChecked = !this.payZFBChecked
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .payCert {
        width: @a;
        height: auto;
        margin-left: 4%;

        .title {
            width: @a;
            height: 24px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: bolder;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
        }

        .pay {
            width: @a;
            height: auto;
            margin-top: 27px;
            padding: 5px;

            .pay_btn {
                width: @a;
                height: 80px;
                @row();

                .btn {
                    width: 520px;
                    height: 80px;
                    line-height: 80px;
                    text-align: center;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#000000,
                    #000000);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    letter-spacing: 1px;
                    color: #ffffff;
                    font-size: 24px;
                    cursor: pointer;
                }
            }

            .line {
                width: @a;
                height: 4px;
                margin: 30px 0;
                background-image: linear-gradient(to right,
                grey 0%,
                grey 50%,
                transparent 50%);
                background-size: 30px 1px;
                background-repeat: repeat-x;
            }

            .select {
                width: @a;
                height: auto;
                display: @flex;
                align-items: center;
                font-size: 24px;
                font-weight: bolder;
                padding-left: 20px;

                .moneyPay {
                    width: 50%;
                    height: 150px;
                    display: @flex;
                    align-items: center;

                    img {
                        width: 70px;
                        height: 70px;
                        object-fit: cover;
                        margin: 0 15px;
                    }
                }
            }

            .mkll {
                width: @a;
                height: auto;
                margin-top: 20px;
                font-weight: bolder;
                font-size: 20px;
                display: @flex;
                align-items: center;

                span {
                    font-size: 18px;
                    font-weight: 500;
                    margin-left: 5px;
                }

                .money {
                    width: auto;
                    font-size: 28px;
                    font-weight: bolder;
                    margin-left: 5px;

                    span {
                        font-size: 18px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/certificate/payCert.vue